import React from 'react';
import styles from './ScoreRules.module.css';

const ScoreRules = () => {
    return (
        <div className={styles.scoreRulesContainer}>
            <h1>Zasady w turniejach BTT</h1>

            <div className={styles.scoreRulesText}>

                <h5>1. Uczestnicy turniejów BTT </h5>
                <p>
                    W turniejach BTT mogą brać udział wyłącznie osoby grające w tenisa ziemnego na poziomie amatorskim.
                    Z udziału wykluczeni są zawodnicy z przeszłością profesjonalną, wyraźnie przewyższający poziom amatorski, których udział mógłby zakłócić wyrównaną rywalizację.
                </p>

                <h5>2. Mecze w turniejach jednodniowych</h5>
                <p className={styles.nextRow}>Mecze rozgrywane są do dwóch wygranych setów.</p>
                <p className={styles.nextRow}>Pierwsze dwa sety gra się do 4 wygranych gemów.</p>
                <p className={styles.nextRow}>
                    Przy stanie 3:3 rozgrywany jest tiebreak do 7 punktów (z przewagą dwóch punktów).
                </p>
                <p className={styles.nextRow}>
                    W przypadku remisu 1:1 w setach, trzeci set zastępuje super tiebreak do 10 punktów (również z przewagą dwóch punktów).
                </p>

                <p className={styles.nextRow}>
                    Gemy rozgrywane są z tzw. punktem decydującym przy równowadze (no-ad scoring):

                   <li>W deblu stronę odbierającą wybierają odbierający,</li>
                    <li>W singlu kierunek serwisu wybiera serwujący.</li>
                </p>

                <h5>3. Mecze w lidze tenisowej</h5>
                <p className={styles.nextRow}>Mecze ligowe toczą się do dwóch wygranych setów.</p>
                <p className={styles.nextRow}>Każdy z pierwszych dwóch setów rozgrywany jest klasycznie do 6 gemów.</p>
                <p className={styles.nextRow}>Przy stanie 6:6 w secie rozgrywany jest tiebreak do 7 punktów (z przewagą dwóch punktów).</p>
                <p className={styles.nextRow}>Gemy rozgrywane są na przewagi (bez punktu decydującego).</p>
                <p className={styles.nextRow}>W przypadku remisu 1:1 w setach, decydującym setem jest super tiebreak do 10 punktów (z przewagą dwóch punktów).</p>
                <p className={styles.nextRow}>Zawodnicy, którzy ewidentnie unikają rozgrywania meczów, mogą zostać ukarani walkowerem przez organizatora.</p>

                <h5>4. Wprowadzanie wyniku meczu</h5>
                <p>
                    <li>Wynik meczu może wprowadzić do systemu każdy z uczestników danego meczu.</li>
                    <li>Obowiązek wpisania wyniku spoczywa na zwycięzcy meczu.</li>
                </p>

                <h5>5. Klasyfikacja w turniejach "każdy z każdym"</h5>
                <p className={styles.nextRow}>Miejsce w tabeli ustalane jest według następujących zasad:</p>
                <p className={styles.nextRow}> <li>Liczba wygranych setów,</li></p>
                <p className={styles.nextRow}> <li>
                    Różnica gemów (gemy wygrane minus gemy przegrane).
                    <br/>
                    <b>Uwaga:</b> Punkty zdobyte w super tiebreaku są przeliczane proporcjonalnie do liczby gemów w secie:
                    np. super tiebreak do 10 punktów przy setach granych do 4 gemów = wartość tiebreaka liczona jako 4 gemy.
                </li> </p>
                <p className={styles.nextRow}><li>
                    Wynik bezpośredniego meczu między zawodnikami o identycznym bilansie.
                </li></p>

                <h5>6. Potwierdzenie udziału w turnieju jednodniowym</h5>
                <p>Udział w turnieju jednodniowym zostaje potwierdzony automatycznie, jeśli uczestnik nie wypisze się z listy zgłoszeniowej przed zamknięciem zapisów (sobota, godz. 20:00). </p>
                <p>Po zamknięciu zapisów (tj. po godzinie 20:00 w sobotę) w ciągu jednej godziny zostanie opublikowana drabinka turniejowa. Od tego momentu wypisanie się z turnieju nie będzie już możliwe.</p>
                <p>W przypadku nieobecności uczestnika na turnieju, wszystkie jego mecze zostaną uznane za przegrane walkowerem, co skutkuje utratą punktów ELO. </p>

                <h5>7. Rozstrzyganie sporów</h5>
                <p>
                    Organizatorzy turniejów BTT zastrzegają sobie prawo do ostatecznego rozstrzygania wszelkich kwestii spornych powstałych podczas trwania rozgrywek.
                </p>
            </div>
        </div>
    );
};

export default ScoreRules;